import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {apiRequest} from '../utils/api';
import '../styles/pages/admin.css';
import Footer from '../components/Footer';
import {Modal} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import LoginModal from '../components/LoginModal';
import Alert from '../components/Alert';

const LoginRegisterPage = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('login');
    const [form, setForm] = useState({
        userId: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
    });
    const [error, setError] = useState('');
    const userInfo = JSON.parse(localStorage.getItem('user'));
    const userId = userInfo?.id;

    const [emailVerified, setEmailVerified] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [sentCode, setSentCode] = useState('');
    const [opened, {open, close}] = useDisclosure(false);
    const [alertState, setAlertState] = useState({isOpen: false, message: ''});
    const tagnum = new URLSearchParams(window.location.search).get('tagnum');
    if (tagnum) {
        sessionStorage.setItem('tagnum', tagnum);
    }

    const showAlert = (message, icon = '/assets/icons/modal-alert.svg') => { setAlertState({ isOpen: true, message}); };
    const closeAlert = () => {setAlertState({ isOpen: false,  message: ''});};

    const handleChange = e => {
        setForm({...form, [e.target.name]: e.target.value});
    };

    const handleLogin = async e => {
        e.preventDefault();
        try {
            const data = await apiRequest('/login', 'POST', {
                userId: form.userId,
                password: form.password,
            });

            if (data.success) {
                localStorage.setItem('user', JSON.stringify({state: data.user.STATE, id:data.user.ID}));
                window.dispatchEvent(new Event('login'));
                if(data.user.STATE === 'R'){
                    navigate('/');
                }else{
                    navigate('/privacyConsent');
                }
            } else {
                setError(data.message || '아이디 또는 비밀번호가 올바르지 않습니다.');
            }
        } catch (err) {
            const match = err.message.match(/"message":"(.*?)"/);
            const extractedMessage = match ? match[1] : "알 수 없는 오류입니다.";
            setError(extractedMessage);
        }

    };

    const handleRegister = async e => {
        e.preventDefault();
        if (form.password !== form.confirmPassword) {
            setError('비밀번호가 일치하지 않습니다.');
            return;
        }

        if (!isValidPhoneNumber(form.phone)) {
            setError('전화번호 형식이 올바르지 않습니다. 예: 01012345678');
            return;
        }

        if (verificationCode !== sentCode) {
            setError('인증번호가 올바르지 않습니다.');
            return;
        }

        try {
            const data = await apiRequest('/register', 'POST', {
                userId: form.userId,
                email: form.email,
                phone: form.phone,
                password: form.password,
            });
            if (data.affectedRows === 1) {
                showAlert('회원가입 성공!');
                setTimeout(() => {
                    setActiveTab('login');
                }, 2000);
            } else {
                setError(data.message || '회원가입 실패');
            }
        } catch (err) {
            setError('회원가입 오류');
        }
    };

    const handleSendVerificationCode = async () => {
        if (!form.email) {
            showAlert('이메일을 입력해주세요.');
            return;
        }
        try {
            const res = await apiRequest('/send-verification-code', 'POST', {
                email: form.email,
            });
            if (res.success) {
                showAlert('인증번호가 전송되었습니다.');
                setSentCode(res.code); // 서버에서 반환한 인증코드 저장
            } else {
                showAlert('이메일 전송 실패');
            }
        } catch (err) {
            showAlert('서버 오류');
        }
    };

    const isValidPhoneNumber = phone => {
        return /^01[0-9]{8,9}$/.test(phone); // 01012345678 ~ 01123456789 형식
    };

    const handleModalOpen = () => {
        open();
    };

    const handleSetUserId = (id) => {
        setForm((prev) => ({ ...prev, userId: id }));
        close();
    };


    return (
        <div className="login-container">
            <p className="logo-text gmarket-font">모바일 순찰 시스템</p>
            <img src="/assets/images/daedeok-logo.svg" alt="logo" className="logo"/>

            <div className="form-card">
                {activeTab === 'login' ? (
                    <>
                        <form onSubmit={handleLogin}>
                            <input
                                className="login-input gmarket-font"
                                name="userId"
                                placeholder="아이디를 입력하세요"
                                value={form.userId}
                                onChange={handleChange}
                                required
                           autoComplete="username"
                            />
                            <input
                                className="login-input gmarket-font"
                                type="password"
                                name="password"
                                placeholder="비밀번호를 입력하세요"
                                value={form.password}
                                onChange={handleChange}
                                required
                                  autoComplete="current-password"
                            />
                            <button type="submit" className='gmarket-font'>로그인</button>
                            <div className="find-id-password gmarket-font" onClick={handleModalOpen}>아이디/비밀번호 찾기</div>
                            {error && <p className="error-text">{error}</p>}
                        </form>
                        <Footer/>
                    </>
                ) : (
                    <form onSubmit={handleRegister}>
                        <label>아이디</label>
                        <input
                            name="userId"
                            value={form.userId}
                            onChange={handleChange}
                            required
                        />
                        <label>이메일</label>
                        <div className="email-verify-wrap">
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                required
                            />
                            <button type="button" onClick={handleSendVerificationCode}>
                                이메일 인증받기
                            </button>
                        </div>
                        <label>인증번호 입력</label>
                        <input
                            name="verificationCode"
                            value={verificationCode}
                            onChange={e => setVerificationCode(e.target.value)}
                            required
                        />
                        <label>전화번호</label>
                        <input
                            name="phone"
                            value={form.phone}
                            onChange={handleChange}
                            required
                        />
                        <label>비밀번호</label>
                        <input
                            type="password"
                            name="password"
                            value={form.password}
                            onChange={handleChange}
                            required
                        />
                        <label>비밀번호 확인</label>
                        <input
                            type="password"
                            name="confirmPassword"
                            value={form.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                        <button type="submit">회원가입</button>
                    </form>
                )}
            </div>
            <LoginModal
                opened={opened}
                onClose={close}
                onSetUserId={handleSetUserId}
            />

            <Alert
                isOpen={alertState.isOpen}
                message={alertState.message}
                onConfirm={closeAlert}
            />
        </div>
    );
};

export default LoginRegisterPage;
